import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  input,
  model,
  viewChild
} from '@angular/core';
import {
  ButtonComponent,
  IconComponent,
  OverlayComponent,
  SoftSlotDirective
} from '@softline/ui-core';

/**
 * A filter-bar dropdown built from design-system parts: a `soft-ds-button` trigger
 * ("Title: value", the value in brand colour, truncated with the full text as title) and a
 * connected `soft-ds-overlay` panel with the projected content. Focus follows the overlay:
 * captured on open, trapped while open, restored to the trigger on close (Escape, outside
 * click or `close()`).
 */
@Component({
  selector: 'soft-page-filter-dropdown',
  imports: [ButtonComponent, IconComponent, OverlayComponent, SoftSlotDirective],
  templateUrl: './page-filter-dropdown.component.html',
  styleUrl: './page-filter-dropdown.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageFilterDropdownComponent {
  readonly title = input.required<string>();
  /** the committed value's text; null renders the title alone */
  readonly value = input<string | null>(null);
  readonly icon = input<string | null>(null);
  readonly open = model(false);

  protected readonly trigger = viewChild.required('triggerButton', { read: ElementRef });

  protected readonly fullLabel = computed(() => {
    const value = this.value();
    return value ? `${this.title()}: ${value}` : this.title();
  });

  toggle(): void {
    this.open.update((open) => !open);
  }

  close(): void {
    this.open.set(false);
  }
}
